import { getAccessToken } from "services/tokenStorage";

export const getAuthHeader = () => {
  const token = getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const withAuthHeaders = (headers = {}) => ({
  ...headers,
  ...getAuthHeader(),
});

/**
 * Replace Authorization on an existing set of request headers, whatever shape
 * they arrived in (plain object, Headers, or entry array). Used to re-send a
 * request after the access token has been renewed.
 */
export const replaceAuthHeader = (headers, token) => {
  const merged = new Headers(headers || undefined);
  if (token) {
    merged.set("Authorization", `Bearer ${token}`);
  } else {
    merged.delete("Authorization");
  }
  return merged;
};
